
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentcolor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2a10.032 10.032 0 017.122 3H16a1 1 0 00-1 1 1 1 0 001 1h4.143A1.858 1.858 0 0022 5.143V1a1 1 0 00-1-1 1 1 0 00-1 1v2.078A11.981 11.981 0 00.05 10.9a1.007 1.007 0 001 1.1.982.982 0 00.989-.878A10.014 10.014 0 0112 2zM22.951 12a.982.982 0 00-.989.878A9.986 9.986 0 014.878 19H8a1 1 0 001-1 1 1 0 00-1-1H3.857A1.856 1.856 0 002 18.857V23a1 1 0 001 1 1 1 0 001-1v-2.078A11.981 11.981 0 0023.95 13.1a1.007 1.007 0 00-1-1.1z"}})])
          )
        }
      }
    